module.exports = __webpack_public_path__ + "img/kv.462e1162.jpeg";